export default "__VITE_ASSET__Bx$wsdks__"